import { Box, CircularProgress } from '@mui/material';

const LoadingMoreIndicator = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
      padding: '0.75rem 1rem',
      backgroundColor: '#F8F9FA',
      borderTop: '1px solid #E0E3E7',
    }}
  >
    <CircularProgress size={16} thickness={4} sx={{ color: '#737F86' }} />
    <Box
      component="span"
      sx={{
        fontSize: '0.75rem',
        fontWeight: 500,
        color: '#737F86',
        letterSpacing: '0.01em',
      }}
    >
      Loading more...
    </Box>
  </Box>
);

export default LoadingMoreIndicator;
